import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDaBrowseFaceted } from '@wix/da-types-papi';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import MobileNativeDropdown from '@wix/da-shared-react/pkg/Dropdown/MobileNativeDropdown';
import s from './MobileOrderDropdown.scss';

export interface Props {
  className?: string;
  order?: string;
  orderOptions?: PapiDaBrowseFaceted['orderOptions'];
}

const MobileOrderDropdown: React.FC<Props> = props => {
  const { order, orderOptions = [], className } = props;
  const { t } = useTranslation();
  const onSelect = useCallback(
    selected => {
      const found = orderOptions?.find(o => o.order === selected);
      if (found) {
        window.location.assign(found.url);
      }
    },
    [orderOptions]
  );

  if (!orderOptions.length) {
    return null;
  }

  return (
    <div className={classnames(s['filter-bar'], className)}>
      <label>
        <VisuallyHidden>{t('facetPage.a11y.orderDropdown')}</VisuallyHidden>
        <MobileNativeDropdown
          titleClassName={s['order-dropdown-title']}
          arrowClassName={s['order-dropdown-arrow']}
          title={getOrderTitle(orderOptions, order)}
          onSelect={onSelect}
          items={orderOptions.map(option => ({
            value: option.order,
            label: option.title,
            selected: option.order === order,
            biData: {
              evid: BiEventType.SORT_TYPE_SELECT,
              menu_selection: option.order,
              dropdown_type: 'sort',
            },
          }))}
        />
      </label>
    </div>
  );
};
MobileOrderDropdown.displayName = 'MobileOrderDropdown';
export default MobileOrderDropdown;

function getOrderTitle(orderOptions, order) {
  return orderOptions.find(o => o.order === order)?.title || '';
}
